import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { FC, useState } from 'react';
import i18n from 'i18next';
import { useLanguageSwitcher } from '../../../hooks/useLanguageSwitcher';
import TranslateIcon from '@mui/icons-material/Translate';

import { useTranslation } from 'react-i18next';

const languages: { code: string; name: string }[] = [
  { code: 'en-GB', name: 'English' },
  { code: 'de-DE', name: 'Deutsch' },
  { code: 'es-ES', name: 'Español' },
  { code: 'fr-FR', name: 'Français' },
  { code: 'it-IT', name: 'Italiano' },
  { code: 'ro-RO', name: 'Română' },
  { code: 'pl-PL', name: 'Polski' },
  { code: 'cz-CZ', name: 'Čeština' },
  { code: 'sk-SK', name: 'Slovenčina' },
];

type Props = {
  onLanguageSet: () => void;
}

const LanguageSelector: FC<Props> = ({ onLanguageSet }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const close = () => setOpen(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation('common');

  const { switchLanguage } = useLanguageSwitcher(i18n, close);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChangeLanguage = (event: any) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const onSelect = (isoCode: string) => {
    switchLanguage(isoCode);
    onLanguageSet();
  };

  return (
    <>
      <Box onClick={onChangeLanguage}
        display="flex"
        alignItems="center"
        justifyContent={'flex-start'}
        flexGrow={1}
      >
        <TranslateIcon />
        <Typography
          sx={{
            fontWeight: 600,
            flexGrow: 1,
          }}
          variant="textSM"
          style={{ marginLeft: '15px', fontSize: '16px' }}> {t('changeLanguage')}</Typography>
      </Box>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={close}>
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => onSelect(language.code)}
          >
            <Typography
              sx={{
                fontWeight: 600,
                flexGrow: 1,
              }}
              variant="textSM"
              style={{ marginLeft: '15px', fontSize: '16px' }}>{language.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
